import React, { Component } from 'react';
import axios from "axios";
import { Link } from 'react-router-dom';
import { removewishlist } from '../../utils/byoscart';
import LinesEllipsis from 'react-lines-ellipsis'

import {NotificationContainer, NotificationManager} from 'react-notifications';

import AccountMenu from './AccountMenu';
import Loader from '../utils/Loadersmall';

class Wishlist extends Component {

    constructor(props) {
        super(props);
        this.state = {
            wishlist:[],
            serviceCheck:false,
        }   
    }

    componentDidMount() {
        this.loadWishList();
    }

    async loadWishList() {
        const params = new URLSearchParams();
        params.append('token', localStorage.getItem('byos_token'));
        try {
          const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/wishlistList', params);
           let resVal=response.data;
            if(resVal.status==='success'){
                this.setState({wishlist:resVal.data});
                this.setState({serviceCheck:true});
            }
        } catch (error) {
            this.setState({serviceCheck:true});
          console.error(error);
        }

    }



    localremovewishlist(variation_id){
        removewishlist(variation_id);
        setTimeout(()=>{
            this.loadWishList();
        },1000);
    }


    render() {
        const wishlistCount = this.state.wishlist.length;

        return (
            <div className="ps-account-page ps-wishlist-page ps-account-page--profile">
                <div className="ps-categogy ps-categogy--separate ps-account-shell">
                    <div className="container whiteContainer ps-account-shell__container">
                        <div className="row">
                            <div className="col-12 col-md-3">
                                <AccountMenu/>
                            </div>
                            <div className="col-12 col-md-9">
                                <div className="ps-wishlist__content">
                                <ul className="ps-breadcrumb">
                                    <li className="ps-breadcrumb__item"><Link to="/">My Stuff</Link></li>
                                    <li className="ps-breadcrumb__item active" aria-current="page">Wishlist</li>
                                </ul>

                                <section className="ps-wishlist__hero">
                                    <div className="ps-wishlist__heroContent">
                                        <span className="ps-wishlist__eyebrow">Wishlist</span>
                                        <h1>Saved products, neatly organized</h1>
                                        <p>Quickly review items you want to buy later. Your wishlist stays clean, compact, and easy to revisit.</p>
                                    </div>

                                    <div className="ps-wishlist__heroStats">
                                        <div className="ps-wishlist__heroStat">
                                            <span>Saved items</span>
                                            <strong>{wishlistCount}</strong>
                                        </div>
                                        <div className="ps-wishlist__heroStat">
                                            <span>Layout</span>
                                            <strong>White card</strong>
                                        </div>
                                    </div>
                                </section>

                                {wishlistCount > 0 ? (
                                    <div className="ps-wishlist__grid">
                                        {this.state.wishlist.map((product_details) => {
                                            return (
                                                <article className="ps-wishlist-card" key={product_details.variation_id}>
                                                    <Link className="ps-wishlist-card__image" to={`/details/${Buffer.from(product_details.variation_id).toString('base64')}/${product_details.product_name}`}>
                                                        {product_details.display_image !== '' ? (
                                                            <figure>
                                                                <img src={product_details.display_image} alt={product_details.product_name} />
                                                            </figure>
                                                        ) : (
                                                            <figure>
                                                                <img src="/assets/img/byos-no-image.png" alt={product_details.product_name} />
                                                            </figure>
                                                        )}
                                                    </Link>

                                                    <div className="ps-wishlist-card__content">
                                                        <div className="ps-wishlist-card__top">
                                                            <Link
                                                                className="ps-wishlist-card__title"
                                                                to={`/details/${Buffer.from(product_details.variation_id).toString('base64')}/${product_details.product_name}`}
                                                            >
                                                                <LinesEllipsis
                                                                    text={product_details.product_name}
                                                                    maxLine="2"
                                                                    ellipsis="..."
                                                                />
                                                            </Link>
                                                            <button
                                                                className="ps-wishlist-card__remove"
                                                                onClick={() => this.localremovewishlist(product_details.variation_id)}
                                                                aria-label={`Remove ${product_details.product_name}`}
                                                            >
                                                                <i className="fa fa-trash-o" aria-hidden="true"></i>
                                                            </button>
                                                        </div>

                                                        <div className="ps-wishlist-card__meta">
                                                            <span className="ps-wishlist-card__pill">Saved for later</span>
                                                            <span className="ps-wishlist-card__pill ps-wishlist-card__pill--muted">Unit price</span>
                                                        </div>

                                                        <div className="ps-wishlist-card__priceRow">
                                                            <span className="ps-wishlist-card__price">&#8377;{product_details.offer_price}</span>
                                                            <span className="ps-wishlist-card__strike">&#8377;{product_details.selling_price}</span>
                                                        </div>
                                                    </div>
                                                </article>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div className="ps-wishlist__emptyCard">
                                        <div className="ps-wishlist__emptyMedia">
                                            <img src="/assets/img/wishlist-empty.svg" alt="No wishlist items" />
                                        </div>
                                        <div className="ps-wishlist__emptyContent">
                                            <span className="ps-wishlist__emptyLabel">Nothing saved yet</span>
                                            <h4>No record found</h4>
                                            <p>Browse products and tap the wishlist icon to save items you want to revisit later.</p>
                                            <Link to="/" className="ps-btn ps-btn--sm ps-btn--warning">Start shopping</Link>
                                        </div>
                                    </div>
                                )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <NotificationContainer/>
            </div>
        );
    }
}

export default Wishlist;
